const Reason = {
  Api: 'Api',
  Render: 'Render',
  Router: 'Router',
};

class RUMError extends Error {
  constructor(message, context) {
    super(message);

    this.context = {
      ...context,
      status: context?.status || context?.rest?.code,
    };
  }
}

export { Reason };

export default RUMError;
